module.exports = __webpack_public_path__ + "static/media/MFD shuru.6ff6079b.pdf";